import { Grid, makeStyles, Paper, Typography } from "@material-ui/core";
import React from "react";
import "../atlas.scss";

const useStyles = makeStyles(() => ({
  // panel: {
  //   padding: "20px",
  //   scrollSnapAlign: "start",
  //   scrollSnapStop: "always"
  // },
  // settingsIconContainer: {
  //   position: "absolute",
  //   right: "12px",
  //   top: "2px"
  // },
  // settingsIcon: {
  //   color: "#112345"
  // }
}));

const AtlasPanel: React.FC<any> = ({
  children,
  title,
  theme,
  xs,
  sm,
  md,
  lg,
  height,
}) => {
  const classes = useStyles(theme);
  const paperStyle = {};
  if (height) {
    paperStyle["height"] = height;
    paperStyle["overflowY"] = "auto";
  }
  if (!xs) {
    xs = 12;
  }
  if (!sm) {
    sm = 12;
  }
  if (!md) {
    md = 12;
  }
  if (!lg) {
    lg = 12;
  }
  return (
    <Grid item xs={xs} sm={sm} md={md} lg={lg}>
      <Paper className="panel" elevation={2} style={paperStyle}>
        <Typography className="panelTitle">{title}</Typography>
        <Grid container>{children}</Grid>
      </Paper>
    </Grid>
  );
};
export default AtlasPanel;
